'use strict'
import moment from 'moment'
import _ from 'lodash'
import { i18n } from '@/utils/i18n.js'

export default class ExportTool {
  static taskListToCsv (taskList, dataOrderingType, aoiMode, aggregateMode, fromDate, toDate, noDataValue, eventFormat, _utcOffset) {
    let files = ExportTool.generateFilesFromTaskList(taskList, dataOrderingType, aoiMode, aggregateMode, fromDate, toDate, _utcOffset)
    let csvFiles = []

    files.forEach((file) => {
      csvFiles.push({
        name: file.name,
        data: ExportTool.generatedFileToCsv(file.content, fromDate, toDate, aggregateMode, noDataValue, eventFormat, _utcOffset)
      })
    })

    return csvFiles
  }

  static generateFilesFromTaskList (taskList, dataOrderingType, aoiMode, aggregateMode, fromDate, toDate, _utcOffset) {
    let files = new Map()

    if (dataOrderingType === 'aoi') {
      let file
      let row
      let rowKey

      taskList.forEach((task) => {
        // SD Suivant le type de donnée, on va remplir ce fichier de manière différente
        switch (task.downloadType) {
          case 'raster':
            task.data.forEach((rasterData) => {
              // SD On récupère le fichier à remplir pour cette tâche
              file = ExportTool.getOrCreateNewFile(files, task, rasterData.header.id, aoiMode, fromDate, toDate, aggregateMode, dataOrderingType, _utcOffset)

              rasterData.data.forEach((d) => {
                rowKey = ExportTool.getKeyFromDate(d.event, aggregateMode, _utcOffset)
                row = file.content.get(rowKey)
                if (typeof row === 'undefined') row = []

                row.push({
                  headerId: task.objectId,
                  headerName: typeof rasterData.header.unit.hideBrackets === 'undefined' ? `${task.objectName} [${rasterData.header.unit.symbol}]` : `${task.objectName} ${rasterData.header.unit.symbol}`,
                  value: d.value,
                  count: d.count
                })

                file.content.set(rowKey, row)
              })

              // SD On ordre le contenu par rapport au key (les keys contiennent les dates, donc par ordre chronologique)
              file.content = new Map([...file.content].sort())
              files.set(file.key, file)
            })
            break
          case 'station':
            // SD On récupère le fichier à remplir pour cette tâche
            file = ExportTool.getOrCreateNewFile(files, task, task.objectId, aoiMode, fromDate, toDate, aggregateMode, dataOrderingType, _utcOffset)

            task.data.forEach((stationData) => {
              stationData.data.forEach((d) => {
                rowKey = ExportTool.getKeyFromDate(d.event, aggregateMode, _utcOffset)
                row = file.content.get(rowKey)
                if (typeof row === 'undefined') row = []

                // SD S'il existe déjà une donnée de type similaire dans la ligne ET que ce n'est pas un sous-type (extensiomètre par exemple),
                // alors on ne fait rien (limitation: pas plus d'un type de paramètre mesuré par aoi)
                if (typeof row.find((rowData) => { return rowData.headerId === stationData.header.id && typeof stationData.header.parentId === 'undefined' }) !== 'undefined') return

                let headerId = stationData.header.id
                let headerName = typeof stationData.header.unit.hideBrackets === 'undefined' ? `${stationData.header.name} [${stationData.header.unit.symbol}]` : `${stationData.header.name} ${stationData.header.unit.symbol}`

                // SD Si c'est un sous-type (exensiomètre par exemple),
                // Alors on l'aggrège avec son type de donnée
                if (typeof stationData.header.parentId !== 'undefined') {
                  headerId = parseInt(`${stationData.header.parentId}${stationData.header.id}`)
                  headerName = typeof stationData.header.unit.hideBrackets === 'undefined' ? `${stationData.header.parentName} - ${stationData.header.name} [${stationData.header.unit.symbol}]` : `${stationData.header.parentName} - ${stationData.header.name} ${stationData.header.unit.symbol}`
                }

                row.push({
                  headerId: headerId,
                  headerName: headerName,
                  value: d.value,
                  count: d.count
                })

                file.content.set(rowKey, row)
              })
            })

            // SD On ordre le contenu par rapport au key (les keys contiennent les dates, donc par ordre chronologique)
            file.content = new Map([...file.content].sort())
            files.set(file.key, file)
            break
        }
      })
    }

    if (dataOrderingType === 'dataType') {
      let file
      let row
      let rowKey

      taskList.forEach((task) => {
        switch (task.downloadType) {
          case 'raster':
            // SD On récupère le fichier à remplir pour cette tâche
            file = ExportTool.getOrCreateNewFile(files, task, task.objectId, task.downloadType, fromDate, toDate, aggregateMode, dataOrderingType, _utcOffset)

            task.data.forEach((rasterData) => {
              rasterData.data.forEach((d) => {
                rowKey = ExportTool.getKeyFromDate(d.event, aggregateMode, _utcOffset)
                row = file.content.get(rowKey)
                if (typeof row === 'undefined') row = []

                row.push({
                  headerId: rasterData.header.id,
                  headerName: typeof rasterData.header.unit.hideBrackets === 'undefined' ? `${rasterData.header.name} [${rasterData.header.unit.symbol}]` : `${rasterData.header.name} ${rasterData.header.unit.symbol}`,
                  value: d.value,
                  count: d.count
                })

                file.content.set(rowKey, row)
              })

              // SD On ordre le contenu par rapport au key (les keys contiennent les dates, donc par ordre chronologique)
              file.content = new Map([...file.content].sort())
              files.set(file.key, file)
            })
            break
          case 'station':
            task.data.forEach((stationData) => {
              // SD On récupère le fichier à remplir pour cette tâche
              // Si le paramètre est un sous-type (extensiomètre par exemple), alors on récupère le parentId, sinon l'ID
              let fileId = typeof stationData.header.parentId === 'undefined' ? stationData.header.id : stationData.header.parentId
              file = ExportTool.getOrCreateNewFile(files, task, fileId, 'dataType', fromDate, toDate, aggregateMode, dataOrderingType, _utcOffset)

              stationData.data.forEach((d) => {
                rowKey = ExportTool.getKeyFromDate(d.event, aggregateMode, _utcOffset)
                row = file.content.get(rowKey)
                if (typeof row === 'undefined') row = []

                let headerId = task.objectId
                let headerName = typeof stationData.header.unit.hideBrackets === 'undefined' ? `${task.objectName} [${stationData.header.unit.symbol}]` : `${task.objectName} ${stationData.header.unit.symbol}`

                // SD Si c'est un sous-type (exensiomètre par exemple),
                // Alors on l'aggrège avec son type de donnée
                if (typeof stationData.header.parentId !== 'undefined') {
                  headerId = parseInt(`${task.objectId}${stationData.header.id}`)
                  headerName = typeof stationData.header.unit.hideBrackets === 'undefined' ? `${task.objectName} - ${stationData.header.name} [${stationData.header.unit.symbol}]` : `${task.objectName} - ${stationData.header.name} ${stationData.header.unit.symbol}`
                }

                row.push({
                  headerId: headerId,
                  headerName: headerName,
                  value: d.value,
                  count: d.count
                })

                file.content.set(rowKey, row)
              })

              // SD On ordre le contenu par rapport au key (les keys contiennent les dates, donc par ordre chronologique)
              file.content = new Map([...file.content].sort())
              files.set(file.key, file)
            })
        }
      })
    }

    return files
  }

  static getHeaderFromFile (file) {
    let toReturn = new Map()
    file.forEach((value) => value.forEach((d) => toReturn.set(d.headerId, { id: d.headerId, name: d.headerName })))
    return Array.from(toReturn.values())
  }

  static generatedFileToCsv (file, fromDate, toDate, aggregateMode, nodataValue = 'NO_DATA', eventFormat, _utcOffset) {
    // Si le fichier est vide
    if (file.size === 0) return ''

    let header = ExportTool.getHeaderFromFile(file)
    let data = []
    let toReturn = ''

    // SD Remplissage des lignes du tableau
    // On va parcourir "manuellement" la map pour remplir le tableau de donnée.
    // Si une clé n'existe pas, alors nodata
    let currentData
    let tmpData = []
    let tmp

    ExportTool.forEachTimeStep(file, moment.utc(fromDate), moment.utc(toDate), aggregateMode, eventFormat, _utcOffset, (key, start) => {
      tmpData = []
      currentData = file.get(key)

      // SD On ajoute d'abord les dates
      tmpData.push(start)
      // On n'affiche pas de colonne "end" (désactivé ici)
      // if (!(aggregateMode === 'RAW' || aggregateMode === 'NONE')) tmpData.push(end)

      // SD Si cette date n'existe pas dans les données,
      // alors on insère du nodata pour tous les headers
      if (typeof currentData === 'undefined') {
        header.forEach(() => tmpData.push(nodataValue))
        data.push(tmpData)
        return
      }

      // SD On parcourt tous les headers disponibles et on ajoute les données
      // Si ce header n'existe pas, alors on insère du nodata
      header.forEach((h) => {
        tmp = currentData.find((d) => {
          return d.headerId === h.id
        })

        if (typeof tmp === 'undefined' || tmp.count === 0) tmpData.push(nodataValue)
        else tmpData.push(tmp.value)
      })

      data.push(tmpData)
    })

    // SD mise en commun du header et des données et conversion en CSV.
    let tmpHeader = [{ id: 'from', name: i18n.t('Date') }]
    // On n'affiche pas de colonne "end" (désactivé ici)
    // if (!(aggregateMode === 'RAW' || aggregateMode === 'NONE')) tmpHeader.push({ id: 'to', name: i18n.t('Date fin') })

    tmpHeader.push(...header)

    header = tmpHeader.map((h) => h.name)
    data.unshift(header)

    data.forEach((c) => { toReturn += c.join(',') + '\r\n' })

    return toReturn
  }

  static getKeyFromDate (date, aggregateMode, _utcOffset) {
    switch (aggregateMode) {
      case 'NONE':
        return moment.utc(date).utcOffset(_utcOffset).toISOString()
      case 'RAW':
        return moment.utc(date).utcOffset(_utcOffset).format('YYYY.MM.DD HH:mm:SS')
      case 'DD':
        return moment.utc(date).utcOffset(_utcOffset).format('YYYY.MM.DD')
      case 'MM':
        return moment.utc(date).utcOffset(_utcOffset).format('YYYY.MM')
      case 'YYYY':
        return moment.utc(date).utcOffset(_utcOffset).format('YYYY')
      default:
      case 'HH':
        return moment.utc(date).utcOffset(_utcOffset).format('YYYY.MM.DD-HH')
    }
  }

  static getDisplayDateFormat (aggregateMode) {
    switch (aggregateMode) {
      case 'RAW':
      case 'NONE':
        return 'DD.MM.YYYY HH:mm:SS'
      case 'DD':
        return 'DD.MM.YYYY'
      case 'MM':
        return 'MM.YYYY'
      case 'YYYY':
        return 'YYYY'
      default:
      case 'HH':
        return 'DD.MM.YYYY HH:00:00'
    }
  }

  static stepSizeToMomentDuration (stepSize) {
    switch (stepSize) {
      case 'DD':
        return 'd'
      case 'MM':
        return 'M'
      case 'YYYY':
        return 'y'
      default:
      case 'HH':
        return 'h'
    }
  }

  static getDisplayDate (date, aggregateMode, _utcOffset, format) {
    format = typeof format === 'undefined' ? ExportTool.getDisplayDateFormat(aggregateMode) : format
    return moment.utc(date).utcOffset(_utcOffset).format(format)
  }

  static getFileKey (id, type) {
    return `${type}_${id}`
  }

  static getFileName (id, dataOrderingType, type, task, fromDate, toDate, aggregateMode, _utcOffset) {
    let objectName = task.objectName

    if (dataOrderingType === 'aoi' && task.aoiType === 'station' && task.downloadType === 'raster') objectName = task.aoi.find((a) => a.id === id).name
    if (dataOrderingType === 'aoi' && task.aoiType === 'shapefile' && task.downloadType === 'raster') objectName = '' + task.data[id].header.name
    if (dataOrderingType === 'aoi' && task.aoiType === 'geom' && task.downloadType === 'raster') objectName = task.aoi.find((a) => a.id === id).geometryName
    if (dataOrderingType === 'dataType' && task.downloadType === 'station') objectName = task.dataSource.find((d) => d.id === id).name

    objectName = objectName.replace(/\s/g, '_')

    if (aggregateMode === 'NONE') {
      if (typeof fromDate !== 'undefined' && typeof toDate !== 'undefined') {
        return `${moment.utc(fromDate).utcOffset(_utcOffset).format('YYYYMMDD')}_${moment.utc(toDate).utcOffset(_utcOffset).format('YYYYMMDD')}_${objectName}.csv`
      }
      return `${objectName}.csv`
    }
    return `${moment.utc(fromDate).utcOffset(_utcOffset).format('YYYYMMDD')}_${moment.utc(toDate).utcOffset(_utcOffset).format('YYYYMMDD')}_${aggregateMode}_${objectName}.csv`
  }

  static getOrCreateNewFile (files, task, id, type, fromDate, toDate, aggregateMode, dataOrderingType, _utcOffset) {
    let fileKey = ExportTool.getFileKey(id, type)
    let file = files.get(fileKey)

    if (typeof file !== 'undefined') return file

    return {
      key: fileKey,
      name: ExportTool.getFileName(id, dataOrderingType, type, task, fromDate, toDate, aggregateMode, _utcOffset),
      content: new Map()
    }
  }

  static forEachTimeStep (file, from, to, stepSize, eventFormat, _utcOffset, callback) {
    if (!(stepSize === 'RAW' || stepSize === 'NONE')) {
      // Si le stepSize ne vaut pas RAW (donnée brute) ou NONE (aucune aggrégation faite - ne pas interpréter event comme une date),
      // alors on parcours de manière linéaire la plage de date, de "from" à "to",en incrémentant de 1 stepSize
      let currentStart = moment.utc(from).utcOffset(_utcOffset)
      let currentEnd = moment.utc(currentStart).utcOffset(_utcOffset).add(1, ExportTool.stepSizeToMomentDuration(stepSize))

      while (currentStart.isBefore(to)) {
        callback(
          ExportTool.getKeyFromDate(currentStart, stepSize, _utcOffset),
          ExportTool.getDisplayDate(currentStart, stepSize, _utcOffset),
          ExportTool.getDisplayDate(currentEnd, stepSize, _utcOffset)
        )
        currentStart = moment.utc(currentEnd).utcOffset(_utcOffset)
        currentEnd = moment.utc(currentStart).utcOffset(_utcOffset).add(1, ExportTool.stepSizeToMomentDuration(stepSize))
      }
    } else if (stepSize === 'RAW') {
      // Si le stepSize vaut RAW (donnée brute).
      // alors on parcours les clées du map "file" dans l'ordre
      file.forEach((value, key) => {
        callback(key, ExportTool.getDisplayDate(moment.utc(key, 'YYYY.MM.DD HH:mm:SS').utcOffset(_utcOffset, true), stepSize, _utcOffset), null)
      })
    } else {
      // Si le stepSize vaut NONE (donnée brute) ou autre valeur.
      // alors on parcours les clées du map "file" dans l'ordre
      // Le format de la date à afficher est passée en paramètre
      file.forEach((value, key) => {
        callback(key, moment.utc(key).utcOffset(_utcOffset, true).format(eventFormat), null)
      })
    }
  }

  static getValue (array, key) {
    let found = array.find((mode) => {
      return mode.key === key
    })

    if (typeof found === 'undefined') return found

    return found.value
  }

  static filterParamForStation (station, selectedParamTypes) {
    let found
    let toCompare
    let toReturn = selectedParamTypes.filter((selectedParam) => {
      found = station.measuredParameterTypeIds.find((stationParam) => {
        toCompare = typeof selectedParam.parentId === 'undefined' ? selectedParam.id : selectedParam.parentId
        return stationParam === toCompare
      })
      return typeof found !== 'undefined'
    })

    return _.cloneDeep(toReturn)
  }

  static get emptyUnit () {
    return {
      id: 0,
      name: '',
      symbol: '',
      hideBrackets: true
    }
  }
}
